<template>
  <md-button
    class="button"
    @click="onClick"
    :disabled="disabled"
    :type="type"
    :to="to"
    :href="href"
    :target="target"
  >
    <div v-if="loading">
      <md-progress-spinner
        md-mode="indeterminate"
        :md-diameter="20"
        :md-stroke="2"
      />
    </div>

    <slot />
  </md-button>
</template>

<script>
  export default {
    name: 'x-button',

    props: {
      type: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      to: {
        type: Object
      },
      href: {
        type: String
      },
      target: {
        type: String
      }
    },
    methods: {
      onClick (event) {
        if (!this.disabled && !this.loading) {
          this.$emit('click', event)
        }
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .md-progress-spinner {
    display: flex;
  }
</style>
